<template src="./index.html"></template>
<script>
import common from './index';
export default {
    mixins: [common],
    data: function() {
        return {
            mapTheme: 'broker'
        };
    }
};
</script>
<style lang="scss">
@import './css/broker/index.scss';
</style>
